<template>
  <div class="row">
    <div :class="{'col-lg-12': !quizDetail, 'col-lg-12': quizDetail}">
      <div class="iq-card iq-card-block iq-card-stretch iq-card-height blog blog-detail">
        <div class="iq-card-body">
          <div class="image-block">
            <img :src="quizDetail.app_image" class="img-fluid rounded m-auto d-block" alt="blog-img">
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-cl-8">
            <b> {{quizDetail.app_name}}</b>
          </div>
          <div class="blog-description mt-2">
            <div class="row blog-meta d-flex align-items-center mb-3">
            <div class="col-12 date" v-if="quizDetail.app_date_ts">
                <i class="ri-calendar-2-fill text-primary pr-2"></i>
                {{quizDetail.app_date_ts | dateFormatDDMMYYYYHHMMA}}
              </div>
            </div>
            <div class="" v-if="quizDetail.has_timer">
              <span class="mr-2">Quiz Duration:</span>
              <b-badge
                class="border mr-2 mb-2 font-weight-normal"
                variant="none">
                <span>
                  {{quizDetail.app_duration | durationToDHM}}
                </span>
              </b-badge>
            </div>
            <p class="vhtmlTag vueHtmlParent mt-3 vhtmlUlLi" v-html="quizDetail.app_description">
            </p>
          </div>
        </div>
      </div>
    </div>
    <b-toast
      v-model="showToast"
      name="Toast"
      :variant="toastVariant"
      :title="toastTitle">
      <div v-html="toastMsg">
      </div>
    </b-toast>

  </div>
</template>

<script>
import { socialvue } from "../../../config/pluginInit.js"

export default {
  name: "QuestionQuizInstruction",
  data () {
    return {
      quizDetail: {},
      toastVariant: "",
      showToast: false,
      toastMsg: "",
      toastTitle: "Insttructions"
    }
  },
  props: {
    propAppDetails: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
    socialvue.index()
    this.quizDetail = this.propAppDetails
    console.log(this.quizDetail, "Quiz DetailXXXX")
  }
}
</script>
<style scoped>
:deep(.blog-description p) {
  margin-bottom: 0 !important;
}
</style>
